<template>
    <div class="login-container">
        <header>
            <img style="margin-top: 0px;width: 600px;height: 84px;" src="../../assets/changchenglogo2.png" alt="">
        </header>
        <img class="backimg" src="../../assets/c_bei.png" alt="">
        <div class="content">
            <img src="../../assets/组 68.png" style="z-index: 9999;" alt="">
            <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="欢迎登录" name="first">
                    <el-input placeholder="请输入账号" @focus="handleFocus" prefix-icon="el-icon-user" v-model="input2">
                    </el-input>
                    <el-input placeholder="请输入密码" @focus="handleFocus" prefix-icon="el-icon-lock" v-model="input3">
                    </el-input>
                    <!-- <div style="display: flex;">
                        <el-input style="width: 240px;" placeholder="请输入验证码" prefix-icon="el-icon-search" v-model="input2">
                        </el-input>
                        <div style="width: 105px;height: 38px;border: 1px solid #ccc;margin-top: 10px;margin-left:10px ;"></div>
                    </div> -->
                    <el-button type="warning" style="font-size: 18px;border-radius: 8px;"
                        @click="login()">登&nbsp;录</el-button>
                    <ul>
                        <li @click="register()">
                            注册
                        </li>
                        <li style="margin-left: 20px;">|</li>
                        <li @click="forget()">
                            忘记密码
                        </li>
                    </ul>
                    <div v-if="flag" style="width: 360px;display: flex;text-align: left;line-height: 25px;color:red;">
                        <i class="el-icon-warning" style="margin-top:5px;color: red;;"></i>
                        <p>{{ tsy }}</p>
                    </div>

                </el-tab-pane>
                <!-- <el-tab-pane style="margin-left: 0px;" :disabled="false" label="短信登录" name="second">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item prop="name">
                            <el-input v-model="ruleForm.name" type="text" auto-complete="off"
                                placeholder="请输入获取验证码的手机号">
                                <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-form-item label="" prop="yzm">
                                <div style="display:flex;">
                                    <el-input style="margin-right:5px;width: 80%;" placeholder="请输入您收到的短信验证码"
                                        v-model="ruleForm.yzm"></el-input>
                                    <div style="display:flex;text-align: center;font-size: 17px;cursor: pointer;">

                                        <div class="get-captcha-btn" @click="getCaptcha($event)"
                                            :style="{ backgroundColor: isCounting ? '#DCB780' : '#DCB780', color: isCounting ? '#fff' : '#fff' }">
                                            {{ isCounting ? countdownText : '获取验证码' }}
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form-item>
                    </el-form>
                    <el-button type="warning" style="font-size: 18px;border-radius: 8px;"
                        @click="login()">登&nbsp;录</el-button>
                    <ul>
                        <li @click="register()">
                            注册
                        </li>
                        <li style="margin-left: 20px;">|</li>
                        <li @click="forget()">
                            忘记密码
                        </li>
                    </ul>
                </el-tab-pane> -->

            </el-tabs>
        </div>
    </div>
</template>
<script>
import { login } from '../../request/api.js'
import axios from 'axios';
export default {
    name: 'login',
    data() {
        return {
            activeName: 'first',
            input2: '',
            input3: '',
            flag: false,
            tsy: '',
            loginForm: {

                phone: "",
                yzm: ""
            },
            isCounting: false, // 是否在倒计时
            countdown: 60,     // 倒计时秒数
            countdownText: '', // 倒计时文本
            ruleForm: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: '',
                yzm: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }

                ],
                name1: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' },

                ],
                name2: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                ],
                name3: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],

            },


        }
    },
    methods: {
        getCaptcha(event) {
            event.preventDefault(); // 尝试阻止默认行为
            this.$refs.ruleForm.validateField('name', (valid) => {
                console.log('验证手机号：', valid);

                if (valid) {
                    // 手机号格式正确
                    console.error('手机号格式不正确，请重新输入');
                } else {
                    console.log(this.ruleForm.name, '获取手机号');

                    if (!this.isCounting) {
                        this.isCounting = true;
                        this.countdown = 60;
                        this.countdownText = this.countdown + '秒';
                        this.startCountdown();
                    }
                    // 手机号格式不正确

                    // 这里可以添加额外的逻辑，比如显示错误信息给用户
                }
            });
        },
        startCountdown() {
            if (this.countdown > 0) {
                this.countdown--;
                this.countdownText = this.countdown + '秒';
                setTimeout(this.startCountdown, 1000);
            } else {
                this.isCounting = false;
                this.countdownText = '';
            }
        },
        handleFocus() {
            this.flag = false;
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        register() {
            this.$router.push('/register');
        },
        forget() {
            // this.$router.push('/pw');
            window.open('http://www.cgwcrpt.com/#/pw', '_blank')
            // window.open('http://192.168.1.18:17000/#/pw', '_blank')
        },
        login() {
            let params = {
                username: this.input2,
                password: this.input3
            }

            // axios.post(`http://101.96.133.18:28000/login`, params).then((res) => {
            axios.post(`${process.env.VUE_APP_BASE_LOGIN}/login`, params).then((res) => {
                if (res.data.code == 200) {

                    if (this.input2 == '国科金融') {
                        this.input2 = 'gkjr';
                    }
                    let url = `http://www.cgwcrxt.com/login?username=${encodeURIComponent(this.input2)}&password=${encodeURIComponent(this.input3)}&token=${encodeURIComponent(res.data.token)}`;
                    sessionStorage.removeItem('token');

                    const timestamp = new Date().getTime();
                    // let url = `http://192.168.1.18:17001/login?username=${encodeURIComponent(this.input2)}&password=${encodeURIComponent(this.input3)}&token=${encodeURIComponent(res.data.token)}`;
                    // console.log(url);

                    window.open(url, '_blank')
                } else {
                    this.flag = true;
                    this.tsy = res.data.msg;
                    // this.$message({
                    //     message:'您的账号暂未激活，请返回注册；已提交注册申请的用户，请耐心等待审核结果，或致电155-电话咨询。',
                    //     type: 'info'
                    // });
                }
            }).catch((err) => {
                this.flag = true;

                this.tsy = res.data.msg;
                // this.$message({
                //         message:' ',
                //         type: 'info'
                //     });

            })
            // process.env.VUE_APP_BASE_API + 

            // if(this.input2 == '国科金融'){
            //     this.input2 = 'gkjr';
            // }
            // let url = `http://101.96.133.18:27001/login?username=${encodeURIComponent(this.input2)}&password=${encodeURIComponent(this.input3)}`;
            // // let url = `http://192.168.1.18:80/login?username=${encodeURIComponent(this.input2)}&password=${encodeURIComponent(this.input3)}`;
            // window.open(url,'_blank')

        }
    }
}
</script>
<style scoped lang="scss">
.login-container {
    width: 100%;
    height: 100%;
}

::v-deep .el-input__icon {
    font-size: 20px !important;
}

::v-deep .el-tabs__active-bar {
    background-color: #DCB780;
    // margin-left: 90px;  //===============正式联调时放开

    /* 例如 #ff0000 是红色 */
}

::v-deep .el-input__inner {
    background: rgba(0, 0, 0, 0.06) !important;
    border: none;
    border-radius: 8px;
}

::v-deep .is-active {
    color: black !important;
    text-align: center;
}

::v-deep .el-tabs__nav {
    width: 100%;

}

::v-deep .el-tabs__active-bar {
    width: 100% !important;//==========正式联调时注释掉
    text-align: center;
    //    margin: 0 auto;
}

::v-deep .el-tabs__item {
    margin-right: 0px;
    font-size: 18px;
}

::v-deep #tab-second {
    // margin-left: 70px;
}

header {
    width: 100%;
    height: 80px;
    font-size: 30px;
    color: #C49958;
    background-color: #F1F1F1;
    line-height: 80px;
}

.backimg {
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
}

.content {
    width: 880px;
    display: flex;
    margin: 0 auto;
    text-align: center;
    align-items: center;


    img {
        display: block;
        width: 448px;
        height: 539px;
        // padding-left: 432px;
        padding-top: 108px;
        margin-left: -38px;
        z-index: 9999 !important;
    }

    .tabs {

        margin-top: 98px;
        margin-left: 65px;

        .el-input {
            width: 360px;
            height: 50px;
            display: block;
            margin-top: 10px;
        }

        .el-button {
            width: 360px;
            height: 50px;
            background: linear-gradient(180deg, #DCB780 0%, #C49958 100%);
            margin-top: 10px;
            border: none;
        }

        ul {

            width: 240px;
            display: flex;
            margin: 20px auto;
            justify-content: space-between;

            li {
                color: #C49958;
                cursor: pointer;
            }
        }
    }
}

::v-deep .el-tabs__nav-wrap::after {
    display: none;
}

.get-captcha-btn {
    width: 94px;
    height: 40px;
    background: #DCB780;
    font-size: 16px;
    margin-top: 10px;
}

::v-deep .el-form-item__content {
    margin-left: 0 !important;

}

::v-deep .el-form-item {
    margin-bottom: 0 !important;
}
::v-deep .el-form-item__error{
    margin-top: -7px !important;
}
</style>